function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.618 28.616A23.234 23.234 0 0127.384 51.85 23.234 23.234 0 014.15 28.616 23.234 23.234 0 0127.384 5.382a23.234 23.234 0 0123.234 23.234z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.384 5.383v18.41m0 9.381V51.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.031 28.616a4.647 4.647 0 01-4.647 4.647 4.647 4.647 0 01-4.646-4.647 4.647 4.647 0 014.646-4.647 4.647 4.647 0 014.647 4.647z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.263 16.999l15.943 9.205m8.125 4.69l16.173 9.339M47.505 16.999l-15.943 9.205m-8.125 4.69L7.264 40.234"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.267 28.616a25.883 25.883 0 01-25.883 25.883A25.883 25.883 0 011.501 28.616 25.883 25.883 0 0127.384 2.733a25.883 25.883 0 0125.883 25.883z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}));

var SvgWheel = function SvgWheel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wheel.95a0af2e.svg";
export { ForwardRef as ReactComponent };